module.exports = __webpack_public_path__ + "img/illustration-questions.b7d83437.svg";